<template>
  <div class='control-section'>
    <div id='networkDiagram'>
      <div id='diagram-space' class='sb-mobile-diagram'>
        <ejs-diagram
          style='display:block'
          ref='diagramObj'
          id='diagram'
          :nodes='nodes'
          :getNodeDefaults='getNodeDefaults'
          :doubleClick='doubleClick'
          :selectionChange='selectionChange'
          :pageSettings='pageSettings'
          :contextMenuSettings='contextMenuSettings'
          :contextMenuClick='contextMenuClick'
          :contextMenuOpen='contextMenuOpen'
          :width='width'
          :height='height'
          :click='click'
        >
        <!-- '网元图例展示' -->
        <template>
          <NetTypeShow></NetTypeShow>
        </template>
        <!-- 面板信息展示 -->
        <template>
          <PanelBoardShow :alarmShowObj='alarmShowObj'></PanelBoardShow>
        </template>
        <template>
          <NePanelBoardShow :neAlarmShowObj='neAlarmShowObj'></NePanelBoardShow>
        </template>
        <template>
          <TrunkPanelBoardShow :trunkShowObj='trunkShowObj'></TrunkPanelBoardShow>
        </template>
        <template>
          <SubnetPanelBoardShow :subnetShowObj='subnetShowObj'></SubnetPanelBoardShow>
        </template>
      </ejs-diagram>
      </div>
    </div>
    <!-- 添加子网对话框 -->
    <CustomDialog ref='subnetDialog' :subNodes='nodesMap' :element='subnetDialog.element' :styles='subnetDialog.styles' :messages='subnetDialog.messages'>
      <template v-slot:dialog-content>
        <add-subnet ref='addsubnet' @close='cancelSubnet'></add-subnet>
      </template>
    </CustomDialog>
    <!-- 修改子网弹框 -->
    <CustomDialog ref='updateSubnetDialog' :subNodes='nodesMap' :element='upSubnetDialog.element' :styles='upSubnetDialog.styles' :messages='upSubnetDialog.messages'>
      <template v-slot:dialog-content>
        <update-subnet ref='updateSubnet' @close='cancel2Subnet' ></update-subnet>
      </template>
    </CustomDialog>
    <!-- 添加集群对话框 -->
    <CustomDialog ref='trunkDialog' :element='trunkDialog.element' :styles='trunkDialog.styles' :messages='trunkDialog.messages'>
      <template v-slot:dialog-content>
        <add-trunk ref='addtrunk' @close='closeTrunk'></add-trunk>
      </template>
    </CustomDialog>
    <!-- 添加设备对话框 -->
    <CustomDialog ref='devicedialog' :element='devDialog.element' :styles='devDialog.styles' :messages='devDialog.messages'>
      <template v-slot:dialog-content>
        <add-device ref='adddev' @close='closeDevice' ></add-device>
      </template>
    </CustomDialog>
    <!-- 添加网元对话框 -->
    <CustomDialog ref='nedialog' :element='neDialog.element' :styles='neDialog.styles' :messages='neDialog.messages'>
      <template v-slot:dialog-content>
        <add-ne ref='addne' @close='cancelNe'></add-ne>
      </template>
    </CustomDialog>
    <!-- 修改集群 -->
    <CustomDialog ref='updatetrunkdialog' :element='updateTrunckDialog.element' :styles='updateTrunckDialog.styles' :messages='updateTrunckDialog.messages'>
      <template v-slot:dialog-content>
        <UpdateTrunk ref="updatetrunk" @close='close2Trunk' ></UpdateTrunk>
      </template>
    </CustomDialog>
    <!-- 修改设备 -->
    <CustomDialog ref='updateDevice' :element='updateDevDialog.element' :styles='updateDevDialog.styles' :messages='updateDevDialog.messages'>
      <template v-slot:dialog-content>
        <UpdateDevice ref="updatedev" @close='close2Device' ></UpdateDevice>
      </template>
    </CustomDialog>
    <!-- 修改网元 -->
    <CustomDialog ref='updateNedialog' :element='updateNedialog.element' :styles='updateNedialog.styles' :messages='updateNedialog.messages'>
      <template v-slot:dialog-content>
        <UpdateNe ref="updatene" @close='close2Ne'></UpdateNe>
      </template>
    </CustomDialog>
  </div>
</template>
<style>

</style>

<script>
import Vue from 'vue';
import {
  Node,
  DiagramPlugin,
  SymbolPalettePlugin,
  Diagram,
  SnapConstraints,
  NodeConstraints,
  DiagramContextMenu,
  AnnotationConstraints,
} from '@syncfusion/ej2-vue-diagrams';
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { createNamespacedHelpers } from 'vuex';
import CustomDialog from '../common/CustomDialog';
import NetTypeShow from './NetTypeShow';
import PanelBoardShow from './PanelBoardShow';
import NePanelBoardShow from './NePanelBoardShow';
import TrunkPanelBoardShow from './TrunkPanelBoardShow';
import SubnetPanelBoardShow from './SubnetPanelBoardShow';
import AddSubnet from './AddSubnet';
import UpdateSubnet from './UpdateSubnet';
import AddTrunk from './AddTrunk';
import AddDevice from './AddDevice';
import AddNe from './AddNe';
import UpdateTrunk from './UpdateTrunk';
import UpdateDevice from './UpdateDevice';
import UpdateNe from './UpdateNe';
import topoMethods from './TopoCommon';
import socketInstance from '../../plugins/stompSock';
import { EventBus } from '../../plugins/eventBus';

const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

Diagram.Inject(DiagramContextMenu);
Vue.use(DiagramPlugin);
Vue.use(SymbolPalettePlugin);
Vue.use(UploaderPlugin);
Vue.use(ButtonPlugin);

let diagramInstance;

export default {
  name: 'base-physic',
  components: {
    CustomDialog,
    PanelBoardShow,
    NePanelBoardShow,
    TrunkPanelBoardShow,
    SubnetPanelBoardShow,
    NetTypeShow,
    AddSubnet,
    UpdateSubnet,
    AddTrunk,
    AddDevice,
    AddNe,
    UpdateTrunk,
    UpdateDevice,
    UpdateNe,
  },
  created() {
    // this.setAuth();
    this.loadElement();
    this.queryAlarmTimer = setInterval(this.queryAlarm, 10000);
    // this.findAlarmTimer = setTimeout(this.queryAlarm, 2000);
  },
  beforeDestroy() {
    if (this.queryAlarmTimer) {
      clearInterval(this.queryAlarmTimer);
      this.queryAlarmTimer = null;
    }
    if (this.findAlarmTimer) {
      clearTimeout(this.findAlarmTimer);
      this.findAlarmTimer = null;
    }
    socketInstance.stopReceiveTopicMsg(this.payload[0].clientId, this.payload[0].topic);
  },
  mixins: [topoMethods],
  props: ['dataSource'],
  watch: {
   
  },
  data() {
    return {
      nodes: [],
      isLogical: false, // 物理视图
      isAdd: false, // 添加或修改元素
      alarmShowObj: { seeObj: false, seeBottomObj: false, idObj: '', typeObj: '' ,onlineObj:'', PositionXY:'right:25px'},
      neAlarmShowObj: { seeObj: false, seeBottomObj: false, idObj: '', typeObj: '',onlineObj:'', PositionXY:'right:25px'},
      trunkShowObj: { seeObj: false, seeBottomObj: false, idObj: '', typeObj: '',onlineObj:''},
      subnetShowObj: { seeObj: false, seeBottomObj: false, idObj: '',onlineObj:'', PositionXY:'right:25px' },
      dClickId: null, // 双击设备或子网缓存id
      dClickPId: null, // 双击设备或子网缓存parentId
      successMsg: this.$t('Track.success'),
      nodeName: '',
      nodeId: '',
      width: '100%',
      height: 'calc(100vh - 140px)',
      see: false,
      seeBottom: false,
      selectNe: '',
      showNetType: false,
      constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs | NodeConstraints.Tooltip,
      offsetX: 0,
      offsetY: 0,
      deleteNodeId: 0,
      deleteNodeType: 0,
      findAlarmTimer: null,
      queryAlarmTimer: null,
      selectNodes: [],
      getNodeDefaults: (node) => {
        node.height = 58;
        node.width = 58;
        return node;
      },
      contextMenuSettings: {
        show: true,
        items: this.menuList(),
        showCustomMenuOnly: true
      },
      contextMenuOpen: (args) => {
        // 保存坐标
        this.offsetX = (args.event && args.event.offsetX) ? args.event.offsetX : 256;
        this.offsetY = (args.event && args.event.offsetY) ? args.event.offsetY : 256;
        const childList = args.element.querySelectorAll('li.e-menu-item');
        const node = diagramInstance.selectedItems.nodes[0];
        let array = [];
        
        //-- 选择多个网元
        if (diagramInstance.selectedItems.nodes.length > 1) {
        	args.cancel = true
			return;
        } 
        
        // 右击空白
        if (node === undefined) 
        {
			//-- 获取当前层网元个数
			const num = diagramInstance.nodes.length;
			//-- 无设备或者网元,不弹出
			if (num === 0) 
			{ 	
				args.cancel = true
				return;
			} 
 
			const isShowAddSubnet = this.isShowSubnetMenu(); // 是否显示“添加子网”
			if(isShowAddSubnet == false)
			{	//-- 点击的不是子网
				args.cancel = true
				return;
			}
		      
			//-- 显示“添加子网”
			array = ['', 'none', 'none'];
			array.forEach((value, index) => {
			  childList[index].style.display = value;
			});
			return;
        }        
        else {
          	// 右击节点
          	if( diagramInstance.selectedItems.nodes[0].type != '0')
          	{
          		args.cancel = true
		      	return;
          	}
  			array = ['none', '', ''];
	  		array.forEach((value, index) => {
	          childList[index].style.display = value;
	        });
	        return;
        }       
      },
      contextMenuClick: (args) => {
        // 右击网元或空白
        const node = diagramInstance.selectedItems.nodes[0];
        // 权限控制如果是Eadmin账户有任何权限
        let username = '';
        let principal = sessionStorage.getItem('principal');
        if (!!principal) {
          let user = JSON.parse(principal);
          username = user.username;
        }
        // 添加子网, 设备, 网元
        if (node === undefined) {
          const brotherNode = diagramInstance.nodes[0];
          // 同层无权限添加, 查找父权限
          let parentId = diagramInstance.nodes[0] ? brotherNode.parentid : undefined;
          if (parentId === undefined) {
            parentId = this.dClickId;
          }
          	
          	//-- fixed NM8000-8275 拓扑页面仅“添加子网 /修改子网/删除子网 ”
            switch(args.item.id) {
              case 'addSubnet':
              	//-- 新增子网不判断权限
                this.isAdd = true;
                if (this.nodes.length > 0) {
                  const pId = this.nodes[0].parentid;
                  const currentNodes = diagramInstance.nodes;
                  this.$refs.addsubnet.initData(this.getPhysicalById(pId), currentNodes);
                }
                // this.upSubnetDialog.element.title = this.$t('Topo.addSubnet');
                this.$refs.addsubnet.bindValidate();
                this.$refs.subnetDialog.show();
                break;             
             }
        } 
        else {
          // 修改操作的权限
          this.getAuth(username, node.id).then(result => {
           
            switch (args.item.id) {
              case 'editSubnet':
              	//-- NM8000-8275 修改后就只有 ：添加子网 / 修改子网/删除子网 。 修改子网与删除子网需要判断权限
              	if (!result) {
	              EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.permissionDenied') });
	              return;
	            }
              	//-- 修改子网不判断权限
                this.isAdd = false;
                this.axios.get(`/lte/ems/topo/subnet/findSubnet/${node.id}`).then(response => {
                  if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
                    const subnetInfo = response.data.resultVal;
                    this.$refs.updateSubnet.initData('update', subnetInfo, this.nodes);
                    this.$refs.updateSubnet.bindValidate();
                    this.$refs.updateSubnetDialog.show();
                  } else {
                    if (response.data.errorString) {
                      EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
                    }
                  }
                });
                break;             
              case 'delSubnet':  
              	//-- NM8000-8275 修改后就只有 ：添加子网 / 修改子网/删除子网 。 修改子网与删除子网需要判断权限            
              	if (!result) {
	               EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.permissionDenied') });
	               return;
	            }
                if (node && node.type !== undefined) {
                  // 删除参数id, type
                  this.deleteNodeId = node.id;
                  this.deleteNodeType = node.type;
                  this.$layer.confirm({
                    msg: this.$t('MCS.deleteConfirm'),
                    btn1: {
                      msg: this.$t('System.cancel'),
                    },
                    btn2: {
                      msg: this.$t('System.confirm'),
                      func: this.deleteNe,
                    }
                  });
                } else {
                  console.log('网元或类型为空');
                }
                break;
            }
          });
        }
      },
      pageSettings: {
        margin: {top: 10, left: 0, right: 0, bottom: 0},
        width: document.body.clientWidth - 300,
        height:1500,
        showPageBreaks: false,
        boundaryConstraints: 'Page', //Diagram
      },
      snapSettings: { constraints: SnapConstraints.None }, // 网格
      element: {
        // target: '#app',
        refName: 'add',
        isClose: true
      },
      scrollSettings: {
        canAutoScroll: false,
        scrollLimit: 'Diagram',
        horizontalOffset: 0,
        verticalOffset: 0,
        currentZoom: 1,
        maxZoom: 1.2,
        minZoom: 0.1,
      },

      selectionChange: args => {

        try {
	          if (args.type === 'Addition' && args.state === 'Changed') {
		            if (args.newValue && args.newValue.length === 1) {
		              this.selectNodes.push(args.newValue[0]);
		            } else {
		              this.selectNodes = args.newValue;
		            }
	          }
        } catch (e) {
      		  console.log(e);
        }
        if (args.type === 'Addition' && args.state === 'Changed' && args.newValue.length === 1) {

          const node = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === args.newValue[0].id)];
          args.oldValue.forEach(node => {
            if (node.propName === "nodes") {
              node.style.strokeColor = "red";
              node.style.strokeWidth = 0;
            } else {
              node.style.strokeWidth = 0;
            }
          });
          const selectNode = []; // 选中网元
          if (args.newValue instanceof Array && args.newValue.length > 0) {           
            selectNode.push(node);           
          }
          this.nodeId = node.id.substring(1, args.newValue[0].id.length);
          if (node.type > 1 && node.type < 10000) {
            this.neAlarmShowObj.seeObj = true;
            this.neAlarmShowObj.seeBottomObj = true;
            this.neAlarmShowObj.idObj = node.id;
            this.neAlarmShowObj.typeObj = node.type;
            this.neAlarmShowObj.onlineObj = node.isOnline;
            //-- fixed NM8000-8033 
            if (args.newValue[0].offsetX >= document.body.clientWidth - (340 + 325) && args.newValue[0].offsetY <= 380)
              	this.neAlarmShowObj.PositionXY = 'left:25px';
            else
              	this.neAlarmShowObj.PositionXY = 'right:25px';

          } 
          else if (node.type >= 10001 && node.type != 20001) {
            this.alarmShowObj.seeObj = true;
            this.alarmShowObj.seeBottomObj = true;
            this.alarmShowObj.idObj = node.id;
            this.alarmShowObj.typeObj = node.type;
            this.alarmShowObj.onlineObj = node.isOnline;
             //-- fixed NM8000-8033 
            if (args.newValue[0].offsetX >= document.body.clientWidth - (340 + 325) && args.newValue[0].offsetY <= 380)
              	this.alarmShowObj.PositionXY = 'left:25px';
            else
              	this.alarmShowObj.PositionXY = 'right:25px';
          } 
          else if (node.type === 20001) {
            this.trunkShowObj.seeObj = true;
            this.trunkShowObj.seeBottomObj = true;
            this.trunkShowObj.idObj = node.id;
            this.trunkShowObj.typeObj = node.type;
            this.trunkShowObj.onlineObj = node.isOnline;
          } 
          else if(node.type === 0) {
            this.subnetShowObj.seeObj = true;
            this.subnetShowObj.seeBottomObj = true;
            this.subnetShowObj.idObj = node.id;
            this.subnetShowObj.onlineObj = node.isOnline;
            //-- fixed NM8000-8033 
            if (args.newValue[0].offsetX >= document.body.clientWidth - 290 - 325 && args.newValue[0].offsetY <= 335)
              	this.subnetShowObj.PositionXY = 'left:25px';
            else
              	this.subnetShowObj.PositionXY = 'right:25px';
          }
        } 
        else {
          this.alarmShowObj.seeObj = false;
          this.alarmShowObj.seeBottomObj = false;
          this.neAlarmShowObj.seeObj = false;
          this.neAlarmShowObj.seeBottomObj = false;
          this.trunkShowObj.seeObj = false;
          this.trunkShowObj.seeBottomObj = false;
          this.subnetShowObj.seeObj = false;
          this.subnetShowObj.seeBottomObj = false;
        }
      },
      // 添加子网对话框
      subnetDialog: {
        element: {
          title: this.$t('Topo.addSubnet'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.subnetMan'),
          buttonGroup: [
            { click: this.cancelSubnet, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.addSubnet, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '780px',
          height: '660px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t('Topo.addSubnet'),
        }
      },
      // 修改子网对话框
      upSubnetDialog: {
        element: {
          title: this.$t('Topo.updateSubnet'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.subnetMan'),
          buttonGroup: [
            { click: this.cancel2Subnet, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.update2Subnet, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '800px',
          height: '720px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t('Topo.updateSubnet'),
        }
      },
      trunkDialog: {
        element: {
          title: this.$t('Topo.addTrunk'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.trunkManager'),
          buttonGroup: [
            { click: this.closeTrunk, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.addTrunk, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '800px',
          height: '580px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t('Topo.addTrunk'),
        }
      },
      // 添加设备对话框
      devDialog: {
        element: {
          title: this.$t('Topo.addDev'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.devManager'),
          buttonGroup: [
            { click: this.closeDevice, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.addDeviceSubmit, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '800px',
          height: '700px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t('Topo.addDev'),
        }
      },
      // 添加网元对话框
      neDialog: {
        element: {
          // target: '#app',
          title: this.$t('Topo.addNe'),
          isClose: true,
          refName: this.$t('Topo.neManager'),
          buttonGroup: [
            { click: this.cancelNe, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.submitNe, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '680px',
          height: '573px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title: this.$t('Topo.addNe'),
        }
      },
      // 修改集群
      updateTrunckDialog: {
        element: {
          title: this.$t('Topo.editTrunk'),
          isClose: true,
          refName: this.$t('Topo.trunkManager'),
          buttonGroup: [
            { click: this.close2Trunk, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.updateTrunk, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
          ]
        },
        styles: {
          width: '680px',
          height: '575px',
          visible: false,
          model: true,
          zIndex: 1000,
        },
        messages: {
          title:this.$t('Topo.editTrunk'),
        }
      },
      // 修改设备
      updateDevDialog:{
	        element: {
	          title: this.$t('Topo.editDev'),
	          // target: '#app',
	          isClose: true,
	          refName: this.$t('Topo.devManager'),
	          buttonGroup: [
	            { click: this.close2Device, buttonModel: { content: this.$t('Topo.cancel') } },
	            { click: this.updateDevice, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
	          ]
	        },
	        styles: {
	          width: '800px',
	          height: '700px',
	          visible: false,
	          model: true,
	          zIndex: 1000,
	        },
	        messages: {
	          title: this.$t('Topo.devModify'),
	        }
      },
      // 修改网元
      updateNedialog: {
	        element: {
	          title: this.$t('Topo.editNe'),
	          isClose: true,
	          refName: this.$t('Topo.neManager'),
	          buttonGroup: [
	            { click: this.close2Ne, buttonModel: { content: this.$t('Topo.cancel') } },
	            { click: this.updateNe, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } },
	          ]
	        },
	        styles: {
	          width: '680px',
	          height: '573px',
	          visible: false,
	          model: true,
	          zIndex: 1000,
	        },
	        messages: {
	          title: this.$t('Topo.neModify'),
	        },
	      },
	      payload: [
	        { topic: '/topic/ElementServer', clientId: 'topo', callback: this.subscribeCallback },
	      ]
    };
  },
  mounted() {
	    socketInstance.init(this.payload);
	    diagramInstance = this.$refs.diagramObj.ej2Instances;
	    delete diagramInstance.commands.delete;
	    delete diagramInstance.commands.copy;
	    delete diagramInstance.commands.paste;
	    delete diagramInstance.commands.cut;
  },
  computed: {
    ...mapGetters(['physicalNodes', 'logicalNodes', 'getParentNe', 'getTypeByCode']),
  },
  methods: {
    ...mapActions(['setPhysical', 'addPhysical', 'delPhysicalNodes', 'setParentNe']),
    // 加载网元
    async loadElement() {
      await this.loadGraph(this.isLogical);
      this.findAlarmTimer = setTimeout(this.queryAlarm, 2000);
      // this.queryAlarm();
    },
    // 首次加载物理/逻辑视图, 并将网元放入缓存
    loadGraph(logical) {
      const _this = this;
      const dataNodes = [];
      // 权限集合
      // const authList = this.getAuthList;
      const isLogical = logical;
      this.nodes = [];
      const nodesMap = new Map();
      nodesMap.clear();
      this.axios.post('/lte/ems/topo/treeData').then((response) => {
        response.data.resultVal.forEach(element => {
          const node = this.createElement(element);
          if (node.parentid === 0 || node.parentid === '' || node.parentid === null || node.parentid === undefined) {
            dataNodes.push(node);
          }
          nodesMap.set(node.id, node);
        });
        _this.nodes = dataNodes;
        if (nodesMap.size > 0) {
          if (isLogical) {
            this.setLogical(nodesMap);
          } else {
            // this.physicalNodes.clear();
            this.setPhysical(nodesMap);
          }
        }
      });
      // return this.nodes;
    },
    // 给拓扑树发送当前选中网元id
    sendMessage(NeID) {
      console.log('ggNeID2', NeID);
      this.$emit('sendInfo', NeID);
    },
    isShowSubnetMenu() {
      const nodes = diagramInstance.nodes;
      if (!nodes)
        return false;
      let num = 0;
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].type === 0 || nodes[i].type >= 10000) {
          num++;
          if (num >= 2) {
            return true;
          }
        }
      }
      return false;
    },
    deleteNe() {
      const neId = this.deleteNodeId;
      const type = this.deleteNodeType;
      const param = { id: neId };
      if (type !== undefined && (type === 0)) {
        this.axios.get(`/lte/ems/topo/subnet/findSubnet/${neId}`).then(response => {
          let subnetInfo;
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            subnetInfo = response.data.resultVal;
          } else {
            subnetInfo = param;
          }
          this.axios.post('/lte/ems/topo/subnet/deleteSubnet', {...subnetInfo}).then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              diagramInstance.remove(diagramInstance.nodes[neId]);
              this.delPhysicalNodes(neId);
              EventBus.$emit('toast', {type: 'success', content: this.successMsg});
            } else {
              if (response.data.errorString) {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            }
          });
        });
      } else if (type === 20001) {
        this.axios
          .post(`/lte/ems/topo/trunk/deleteTrunk/${neId}`)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              diagramInstance.remove(
                diagramInstance.nodes[neId]
              );
              this.delPhysicalNodes(neId);
              EventBus.$emit('toast', {type: 'success', content: this.successMsg});
            } else {
              if (response.data.errorString) {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            }
          });
      } else if (type >= 10000) {
        this.axios
          .post(`/lte/ems/topo/device/deleteDev/${neId}`)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              diagramInstance.remove(
                diagramInstance.nodes[neId]
              );
              this.delPhysicalNodes(neId);
              EventBus.$emit('toast', {type: 'success', content: this.successMsg});
            } else {
              if (response.data.errorString) {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            }
          });
      } else {
        this.axios
          .post(`/lte/ems/topo/ne/deleteNe/${neId}`)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              diagramInstance.remove(
                diagramInstance.nodes[neId]
              );
              this.delPhysicalNodes(neId);
              EventBus.$emit('toast', {type: 'success', content: this.successMsg});
            } else {
              if (response.data.errorString) {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            }
          });
      }
    },
    // 添加子网保存
    addSubnet() {
      let subnetPId = undefined;
      if (this.nodes && this.nodes.length > 0) {
        subnetPId = this.nodes[0].parentid;
      }
      this.$refs.addsubnet.outputs(subnetPId, this.offsetX, this.offsetY);
    },
    cancelSubnet() {
      this.$refs.subnetDialog.clear();
      this.$refs.subnetDialog.close();
      this.$refs.addsubnet.initData();
    },
    // 修改子网保存
    update2Subnet() {
      this.$refs.updateSubnet.outputs(this.isAdd, this.offsetX, this.offsetY);
    },
    cancel2Subnet() {
      this.$refs.updateSubnetDialog.clear();
      this.$refs.updateSubnetDialog.close();
    },
    // 添加集群保存
    addTrunk() {
      this.$refs.addtrunk.outputs(this.isAdd, this.offsetX, this.offsetY);
    },
    closeTrunk() {
      this.$refs.trunkDialog.clear();
      this.$refs.trunkDialog.close();
      this.$refs.addtrunk.initData();
    },
    // 添加设备保存
    addDeviceSubmit() {
      let subnetId = undefined;
      if (this.nodes && this.nodes.length > 0) {
        subnetId = this.nodes[0].parentid;
      }
      this.$refs.adddev.outputs(this.isAdd, this.offsetX, this.offsetY, subnetId);
    },
    closeDevice() {
      this.$refs.devicedialog.clear();
      this.$refs.devicedialog.close();
      // this.$refs.adddev.initData();
    },
    // 添加网元
    submitNe() {
      this.$refs.addne.outputs(this.isAdd, this.offsetX, this.offsetY);
    },
    cancelNe() {
      this.$refs.nedialog.clear();
      this.$refs.nedialog.close();
      this.$refs.addne.initData();
    },
    // 修改集群
    updateTrunk() {
      this.$refs.updatetrunk.outputs();
    },
    close2Trunk() {
      this.$refs.updatetrunkdialog.clear();
      this.$refs.updatetrunkdialog.close();
      this.$refs.updatetrunk.initData();
    },
    // 修改设备
    updateDevice() {
      this.$refs.updatedev.outputs();
    },
    close2Device() {
      this.$refs.updateDevice.clear();
      this.$refs.updateDevice.close();
      this.$refs.updatedev.initData();
    },
    // 修改网元
    updateNe() {
      this.$refs.updatene.outputs();
    },
    close2Ne() {
      this.$refs.updateNedialog.clear();
      this.$refs.updateNedialog.close();
      this.$refs.updatene.initData();
    },
    // 保存坐标
    saveLoc() {
      const nodes = diagramInstance.nodes;
      this.saveLocation(nodes, this.isLogical);
    },
    revert() {
      diagramInstance.scrollSettings.currentZoom = 1;
      diagramInstance.reset();
    },
    selectAll() {
      diagramInstance.selectAll();
      // diagramInstance.group();
    },
    async refresh() {
      try{
        this.$loading.showLoadding(this.$t('Topo.topoLoad'));
        if (this.findAlarmTimer) {
          clearTimeout(this.findAlarmTimer);
          this.findAlarmTimer = null;
        }
        this.$emit('updateTree');
        diagramInstance.clear();
        this.nodes = [];
        await this.loadGraph(this.isLogical);
        this.findAlarmTimer = setTimeout(this.queryAlarm, 1000);
        // this.resetDiagram();
      } catch(e) {
        this.$loading.hideLoadding();
      }
    },
    excelLayout() {
      if (this.nodes.length > 0) {
        this.nodes = this.layout(this.nodes);
      }
    },
    doubleClick(args) {
      if (args.source instanceof Node) {
        const array = this.nextLayer(args, this.isLogical);
        if ((args.source.type === 0 || args.source.type >= 10000) && args.source.type !== 10004 && args.source.type !== 10006 && args.source.type !== 10007) {
          diagramInstance.clear();
          this.nodes = array;
          if (array.length === 0) {
            this.dClickId = args.source.id;
            this.dClickPId = args.source.parentid;
          }
        } else if (array.length > 0) {
          this.nodes = array;
        }
      }
    },

    // 点击树联动拓扑图的边框样式
    receiveTree(treeId) {
      let node = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === treeId.toString())];
      if (node === undefined) {
	        node = this.getPhysicalById(treeId);
	        const parentId = node.parentid ? node.parentid.toString() : null;
	        let nodes = this.findChildren(parentId, false);
	        diagramInstance.clear();
	        this.nodes = nodes;
      }
      else {
	        diagramInstance.nodes.forEach(element => {
	          element.borderWidth = 0;
	        });
      }
    
      try{
        setTimeout(function() {
          node = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === treeId.toString())];
          const selectNode = [];
          selectNode.push(node);
          diagramInstance.select(selectNode)
        },200);
      }catch (e) {
        console.log(e);
      }
    },
    click(args) {
	      this.seeBottom = !this.seeBottom;
	      console.log('selectNode:', this.selectNodes);
	      const clickNode = args.element;
	      const flag = clickNode !== null && clickNode.id !== undefined;
	      if (flag) {
	        this.selectNodes = [];
	        this.sendMessage(args.element.id);	       
	        this.selectNodes.push(clickNode);
	        diagramInstance.select(this.selectNodes);
	      }
    },
    // 拖动网元边界限制
    positionChange(args) {
      if (args.source.nodes !== undefined) {
        let offset = null;
        if (args.newValue.offsetX < 10) {
          offset= 10 - args.newValue.offsetX;
          args.source.nodes.forEach(node => {
            // if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
              node.offsetX += offset;
            // }
          })
        }
        if (args.newValue.offsetY < 10) {
          offset= 10 - args.newValue.offsetY;
          diagramInstance.selectedItems.nodes.forEach(node => {
            // if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
              node.offsetY += offset;
            // }
          })
        }
        offset = this.width - args.source.width - 14;
        if (args.newValue.offsetX > offset) {
          offset= args.newValue.offsetX - offset ;
          args.source.nodes.forEach(node => {
            if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
              node.offsetX -= offset;
            }
          })
        }
        offset = 1500 - args.source.height - 15;
        if (args.newValue.offsetY > offset) {
          offset= args.newValue.offsetY - offset;
          diagramInstance.selectedItems.nodes.forEach(node => {
            // if (node.id.indexOf("cpri") == -1 && node.id.indexOf("sfp") == -1) {
              node.offsetY -= offset;
            // }
          })
        }
      } else {//切换元素未选中状态
        const node = diagramInstance.selectedItems.nodes[0];
        let offset = null;
        if (args.newValue.offsetX < 10) {
          offset= 10 - args.newValue.offsetX;
          node.offsetX += offset;
        }
        if (args.newValue.offsetY < 10) {
          offset= 10 - args.newValue.offsetY;
          node.offsetY += offset;
        }
        offset = this.width - 120 - 14;
        if (args.newValue.offsetX > offset) {
          offset= args.newValue.offsetX - offset ;
          node.offsetX -= offset;
        }
        offset = 1500 - 166 - 15;
        if (args.newValue.offsetY > offset) {
          offset= args.newValue.offsetY - offset;
          node.offsetY -= offset;
        }
      }
    },
    backPrevious() {
      if (this.nodes.length > 0) {
        const array = this.backPre(this.nodes[0], this.isLogical);
        if (array.length > 0) {
          this.nodes = array;
        }
      } else {
        if (this.dClickPId)
          this.dClickPId = this.dClickPId.toString();
        const array = this.findChildren(this.dClickPId, this.isLogical);
        this.nodes = array;
      }
    },
    // 获取网元权限
    async getAuth(username, id) {
      let role = false;
      await this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
        if (response && response.status === 200 && response.data !== undefined) {
          role = response.data;
        }
      });
      if (username === 'Eadmin' || role) return true;
      const authList = [];
      await this.$axios.get('/lte/ems/auth/findAuthNodeList').then(response => {
        if (response && response.status === 200 && response.data && response.data.length > 0) {
          response.data.forEach(element => {
            authList.push(element.nodeId.toString());
          });
        }
      });
      if (!id || authList.length === 0)
        return false;
      return await this.getParentAuth(id.toString(), authList);
    },
    getParentAuth(id, authList) {
      if (authList.indexOf(id) > -1) {
        return true;
      }
      const node = this.getPhysicalById(id);
      if (node) {
        const parentId = node.parentid;
        if (parentId !== null && parentId !== undefined) {
          return this.getParentAuth(parentId.toString(), authList);
        }
      }
      return false;
    },
    // 接收webSocket
    subscribeCallback(wsMessage) {
      const message = JSON.parse(wsMessage.body);
      const event = message.event;     //主题事件
      const element = message.element; //id/idList
      const result = message.result;   //在线状态
      if (event === undefined || element === undefined || result === undefined) {
        return;
      }
      switch (event) {
        case 'CLUSTER_STATUS_CHANGED':
        case 'EQUIPMENT_STATUS_CHANGED':
        case 'NET_ELEMENT_STATUS_CHANGED':
          // 在线状态发送给topoTree
          this.$emit('setTreeOnline', element, result);
          // 批量处理在线状态
          if (element instanceof Array) {
            if (element.length === 0)
              return;
            this.setOnlineStatusForList(element, result);
          } else {
            this.setOnlineStatus(element, result);
          }
          break;
        case 'ADD_SUBNET':
        case 'ADD_CLUSTER':
        case 'ADD_EQUIPMENT':
        case 'ADD_NET_ELEMENT':
          this.addElement(JSON.parse(element));
          break;
        case 'MODIFY_SUBNET':
        case 'MODIFY_CLUSTER':
        case 'MODIFY_EQUIPMENT':
        case 'MODIFY_NET_ELEMENT':
          this.UpdateElement(JSON.parse(element));
          break;
        case 'DELETE_SUBNET':
        case 'DELETE_CLUSTER':
        case 'DELETE_EQUIPMENT':
        case 'DELETE_NET_ELEMENT':
          this.deleteElement(JSON.parse(element));
          break;
      }
    },

    // 批量在线/下线状态
    setOnlineStatusForList(idList, isOnline) {
      idList.forEach(id => {
        this.setOnlineStatus(id, isOnline);
      })
    },

    // 单个网元在线状态
    setOnlineStatus(id, isOnline) {
      const node = this.getPhysicalById(id.toString());
      if (!node || node.isOnline === isOnline)
        return;
      const elementShape = this.iconWithBalloon(node.type, isOnline, node.alarmLevel, node.alarmCount);
      const currentNode = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === id.toString())];
      // 图状态更新
      if (currentNode) {
        currentNode.isOnline = isOnline;
        currentNode.shape.content = elementShape;
      }
      // vuex缓存状态
      node.isOnline = isOnline;
      node.shape.content = elementShape;
    },

    // 更改告警状态
    setAlarmStatus(id, level, count) {
      if(!id) return;
      const node = this.getPhysicalById(id.toString());
      if (!node || !node.isOnline)
        return;
      if (node.alarmLevel !== level || node.alarmCount !== count) {
        // 换图标
        const shape = this.iconWithBalloon(node.type, node.isOnline, level, count);
        // 图上当前网元
        let currentNode = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === id.toString())];
        if (currentNode === undefined) {
          currentNode = node;
        }
        currentNode.shape.content = shape;
        currentNode.alarmLevel = level;
        currentNode.alarmCount = count;
        // vuex中状态
        node.shape.content = shape;
        node.alarmLevel = level;
        node.alarmCount = count;
      }
    },

    // 添加网元websocket
    addElement(wsMessage) {
	      const typeCode = wsMessage.typeCode ? wsMessage.typeCode : 0;
	      const parentId = wsMessage.parentId ? wsMessage.parentId : (wsMessage.clusterId ? wsMessage.clusterId : (wsMessage.equipmentId ? wsMessage.equipmentId : (wsMessage.subnetId ? wsMessage.subnetId : null)));
	      const isOnline = (typeCode === 0) ? 1 : 0;
	      const elementShape = this.baseIcon(typeCode, isOnline);
	      const node = {
	        id: wsMessage.id.toString(),
	        parentid: parentId,
	        type: typeCode,
	        strType: this.getTypeByCode(typeCode),
	        isOnline: isOnline,
	        alarmStatus: -1,
	        offsetX: wsMessage.positionX ? wsMessage.positionX : 226,
	        offsetY: wsMessage.positionY ? wsMessage.positionY : 226,
	        name: wsMessage.name,
	        shape: { type: 'Native', content: elementShape },
	        annotations: [{
	          // content: `${wsMessage.name}`.length > 8 ? `${wsMessage.name.substring(0, 6)}..._${wsMessage.id}` : `${wsMessage.name}_${wsMessage.id}`,
	          content: `${wsMessage.name}`,
	          offset: { x: 0.5, y: 1.30 },
	          margin: { bottom: 10 },
	          constraints: AnnotationConstraints.ReadOnly,
	        }],
	        constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize & ~NodeConstraints.Tooltip & ~NodeConstraints.InheritTooltip) | NodeConstraints.HideThumbs,
	      };
	      
	      this.addPhysical(node);
	      if (this.nodes && this.nodes.length > 0) {
		        const brother = this.nodes[0];
		        if (brother.parentid === parentId || (!brother.parentid && !parentId)) {
		          // this.nodes = diagramInstance.nodes;
		          this.nodes.push(node);
		        }
	      } else {
		        // this.nodes = diagramInstance.nodes;
		        this.nodes.push(node);
	      }
	      if (node.type === 0) {
	        	this.refreshConfirm();
	      }
	      // this.queryAlarm();
	      this.$emit('updateTree');
    },

    // 修改网元的websocket
    UpdateElement(wsMessage) {
      // 过滤保存位置的websocket
      if (wsMessage.name) {
        const parentId = wsMessage.parentId ? wsMessage.parentId : (wsMessage.clusterId ? wsMessage.clusterId : (wsMessage.equipmentId ? wsMessage.equipmentId : (wsMessage.subnetId ? wsMessage.subnetId : null)));
        // 查找缓存
        const cache = this.getPhysicalById(wsMessage.id.toString());
        if (cache !== undefined) {
          if(wsMessage.typeCode >= 10000 && wsMessage.typeCode != 20001) {
            try {
              const devParentId = this.getPhysicalById(wsMessage.id.toString()).parentid;
              if (devParentId != parentId) {
                this.refreshConfirm();
              }
            } catch (e) {
              console.log('设备刷新异常');
            }
          }
          if (cache.name !== wsMessage.name) {
            cache.name = wsMessage.name;
            cache.annotations[0].content = `${wsMessage.name}`;
            // cache.annotations[0].content = `${wsMessage.name}`.length > 8 ? `${wsMessage.name.substring(0, 6)}..._${wsMessage.id}` : `${wsMessage.name}_${wsMessage.id}`;
          }
          if (cache.parentid !== parentId) {
            cache.parentid = parentId;
          }
          // 当前层是否有该网元
          const graphNode = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === wsMessage.id.toString())];
          if (graphNode !== undefined) {
            graphNode.name = wsMessage.name;
            graphNode.annotations[0].content = `${wsMessage.name}`;
            // graphNode.annotations[0].content = `${wsMessage.name}`.length > 8 ? `${wsMessage.name.substring(0, 6)}..._${wsMessage.id}` : `${wsMessage.name}_${wsMessage.id}`;
            graphNode.parentid = parentId;
          }
        }
        if(!wsMessage.typeCode) {
          this.refreshConfirm();
        }
        // this.queryAlarm();
        this.$emit('updateTree');
      }
    },
    // websocket公用删除方法
    deleteElement(element) {
      const id = element.id.toString();
      const node = diagramInstance.nodes[diagramInstance.nodes.findIndex(v => v.id === id)];
      if (node) {
        diagramInstance.remove(node);
      }
      // 删除缓存
      this.delPhysicalNodes(element.id.toString());
      const dataNode = [];
      this.nodes.forEach(ele => {
        if (ele.id !== id) {
          dataNode.push(ele);
        }
      });
      this.nodes = dataNode;
      // this.nodes = diagramInstance.nodes;
      if(!element.typeCode) {
        this.refreshConfirm();
      }
      this.$emit('updateTree');
    },
    refreshConfirm() {
      this.$layer.confirm({
        msg: this.$t('Topo.refresh'),
        btn1: {
          msg: this.$t('System.confirm'),
          func: this.refreshNodes,
        },
      });
    },
    refreshNodes() {
      diagramInstance.clear();
      this.nodes = [];
      this.loadElement();
      // this.nodes = this.loadGraph(this.isLogical);
    },
    // 轮询查告警
    queryAlarm() {
      this.axios.post('/lte/ems/topo/ne/findNeAlarm').then(response => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          if (!result || result.length === 0) {
            this.$loading.hideLoadding();
            return;
          }
          // 存放告警数据
          let alarmIdList = [];
          const alarmMap = new Map();
          result.forEach(alarm => {
            alarmIdList.push(alarm.neId.toString());
            alarmMap.set(alarm.neId.toString(), alarm);
          });
          const physicalNodes = this.physicalNodes;
          if (physicalNodes && physicalNodes.size > 0) {
            physicalNodes.forEach((node,key) => {
              const id = node.id;
              if (alarmIdList.indexOf(id) > -1) {
                const alarmLevel = alarmMap.get(id).level;
                const alarmCount = alarmMap.get(id).count;
                this.setAlarmStatus(id, alarmLevel, alarmCount);
              } else {
                this.setAlarmStatus(id, -1, 0);
              }
            });
          }
                    
          alarmIdList = [];
          alarmMap.clear();
          this.$loading.hideLoadding();
        } else {
          console.log('查询告警出错!');
        }
      });
    },
    resetDiagram() {
      try {
        const diagramStr = diagramInstance.saveDiagram();
        diagramInstance.clear();
        diagramInstance.loadDiagram(diagramStr);
        const selectArray = [];
        if (this.selectNodes.length > 0) {
          this.selectNodes.forEach(element => {
            selectArray.push(element);
          });
          diagramInstance.select(selectArray);
        }
      } catch (e) {
        console.log('复位操作错误...');
      }
    },
  }
};
</script>
